

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: -1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed'
    },
    progress: {
        position: 'absolute',
        top: '30%',
        left: '50%',
        margin: '-5px 0 0 -5px',
    },
});

class Progress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openProgress: props.openProgress
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.openProgress !== this.props.openProgress){
            this.setState({
                openProgress: nextProps.openProgress
            })
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog open={this.state.openProgress}>
                <Paper className={classes.root} elevation={1}>
                    <CircularProgress className={classes.progress} color="secondary" />
                    <div style={{ height: "40vh" }} />
                </Paper>
            </Dialog>
        )
    }
}

export default withStyles(styles)(Progress);


// WEBPACK FOOTER //
// ./src/components/Common/Progress.js